var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { assign, createMachine } from 'xstate';
export var createFlowMachine = function (_a) {
    var onSave = _a.onSave, _b = _a.focusOnInit, focusOnInit = _b === void 0 ? false : _b;
    // TODO: adjust typing here
    return createMachine({
        id: 'createFlow',
        initial: 'input',
        states: {
            input: {
                entry: focusOnInit ? 'setFocus' : undefined,
                on: {
                    REVIEW: {
                        target: 'review',
                        actions: [assign({ item: function (_, event) { return event.item; } }), 'setFocus'],
                    },
                    SAVE_FROM_INPUT: {
                        target: 'saving',
                        actions: [assign({ item: function (_, event) { return event.item; } })],
                    },
                    CANCEL: {
                        actions: ['resetContext', 'resetInputKey', 'setFocus'],
                    },
                },
                exit: assign({ saveError: function (_) { return undefined; } }),
            },
            review: {
                on: {
                    EDIT: { target: 'input', actions: 'setFocus' },
                    SAVE: 'saving',
                    CANCEL: {
                        target: 'input',
                        actions: ['resetContext', 'resetInputKey', 'setFocus'],
                    },
                },
            },
            saving: {
                on: {
                    SET_ITEM: {
                        actions: assign({ item: function (_, event) { return event.item; } }),
                    },
                    DONE: {
                        target: 'confirm',
                        actions: 'setFocus',
                    },
                    ERROR: {
                        target: 'input',
                        actions: [
                            assign({ saveError: function (_, event) { return event.error; } }),
                            'resetInputKey',
                        ],
                    },
                },
                invoke: {
                    id: 'saveItem',
                    // TODO: figure out TS solution here
                    src: function (context) { return function (sendBack) { return __awaiter(void 0, void 0, void 0, function () {
                        var setItem, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    setItem = function (item) {
                                        sendBack({ type: 'SET_ITEM', item: item });
                                    };
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, onSave(context.item, setItem)];
                                case 2:
                                    _a.sent();
                                    sendBack('DONE');
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    sendBack({ type: 'ERROR', error: error_1 });
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); }; },
                },
            },
            confirm: {
                on: {
                    REPEAT: {
                        target: 'input',
                        actions: [
                            'resetContext',
                            'resetInputKey',
                            'setFocus',
                            'onRepeat',
                        ],
                    },
                },
            },
        },
    }, {
        actions: {
            resetContext: assign({
                item: function (_) { return undefined; },
                saveError: function (_) { return undefined; },
            }),
        },
    });
};
//# sourceMappingURL=createFlowMachine.js.map